export default [
  {
    Bootcamp: "4Geeks Academy",
    URL: "https://4geeksacademy.com/es/coding-bootcamps/full-stack-part-time",
    Programa: "Full Stack Python",
    País: "España",
    Estado: "Madrid",
    Costo: 3200,
    Beca: 20,
    Modalidad: "Tiempo completo o parcial",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Academlo",
    URL: "https://www.academlo.com/curso-programacion-web-full-stack",
    Programa: "Full Stack JS",
    País: "México",
    Estado: "",
    Costo: 2250,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "20 - 36 semanas",
    "En línea": "Sí",
    Comentarios: "ISA (12%).",
  },
  {
    Bootcamp: "AwakeLab",
    URL: "https://www.awakelab.cl",
    Programa: "Full Stack Java | Python",
    País: "Chile",
    Estado: "",
    Costo: 2100,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "18 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "BEDU",
    URL: "https://bedu.org/lp/full-stack-javascript/",
    Programa: "Full Stack JS | Python",
    País: "México",
    Estado: "",
    Costo: 1580,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "24 semanas",
    "En línea": "Sí",
    Comentarios: "Becas del 100% en asociación con Becas Santander.",
  },
  {
    Bootcamp: "BIT",
    URL: "https://bit.institute/index?A=index-es",
    Programa: "Full Stack JS",
    País: "Colombia",
    Estado: "",
    Costo: 1230,
    Beca: 10,
    Modalidad: "Tiempo parcial",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Bright Coders",
    URL: "http://www.brightcoders.com",
    Programa: "Full Stack Web | Mobile",
    País: "México",
    Estado: "Colima",
    Costo: 0,
    Beca: 100,
    Modalidad: "Tiempo parcial",
    Duración: "24 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Codeable",
    URL: "https://www.codeable.la/programa",
    Programa: "Full Stack Ruby",
    País: "Internacional",
    Estado: "",
    Costo: 9200,
    Beca: 33,
    Modalidad: "Tiempo completo",
    Duración: "24 semanas",
    "En línea": "Sí",
    Comentarios: "ISA (20%).",
  },
  {
    Bootcamp: "CodeHouse",
    URL: "https://codehouse.academy/bootcamp-fullstack-web-developer/",
    Programa: "Full Stack Web",
    País: "Internacional",
    Estado: "",
    Costo: 4720,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Codenotch",
    URL: "https://www.codenotch.com/bootcamp-de-desarrollo-web-y-movil/",
    Programa: "Full Stack Web | Mobile",
    País: "España",
    Estado: "Madrid",
    Costo: 7788,
    Beca: 24,
    Modalidad: "Tiempo completo",
    Duración: "12 semanas",
    "En línea": "Sí",
    Comentarios: "Becas para mujeres y desempleo.",
  },
  {
    Bootcamp: "Coderhouse",
    URL: "https://www.coderhouse.com/online/carrera-online-desarrollo-fullstack",
    Programa: "Full Stack JS",
    País: "Argentina",
    Estado: "",
    Costo: 1363,
    Beca: 60,
    Modalidad: "Tiempo parcial",
    Duración: "49 semanas",
    "En línea": "Sí",
    Comentarios: "Se ofertan módulos individuales.",
  },
  {
    Bootcamp: "Coding Dojo",
    URL: "https://www.codingdojo.la",
    Programa: "Full Stack JS | Python",
    País: "Chile",
    Estado: "",
    Costo: 4100,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "Parte de codingdojo.com (EEUU)",
  },
  {
    Bootcamp: "Desafío LATAM",
    URL: "https://desafiolatam.com/full-stack-javascript-2022/",
    Programa: "Full Stack JS",
    País: "Chile",
    Estado: "",
    Costo: 2910,
    Beca: 60,
    Modalidad: "Tiempo parcial",
    Duración: "46 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Dev.F",
    URL: "https://www.devf.la",
    Programa: "Full Stack JS",
    País: "Internacional",
    Estado: "",
    Costo: 2849,
    Beca: 30,
    Modalidad: "Tiempo parcial",
    Duración: "52 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Digital House",
    URL: "https://www.digitalhouse.com/ar/curso/programacion-web-full-stack",
    Programa: "Full Stack JS",
    País: "Argentina",
    Estado: "",
    Costo: 2236,
    Beca: 70,
    Modalidad: "Tiempo parcial",
    Duración: "26 semanas",
    "En línea": "Sí",
    Comentarios: "Becas del 70% en asociación con Becas Santander.",
  },
  {
    Bootcamp: "Educación IT",
    URL: "https://www.educacionit.com/index",
    Programa: "Full Stack JS",
    País: "Argentina",
    Estado: "",
    Costo: 238,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "28 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Egg",
    URL: "https://carreras.eggeducacion.com/ar/programacion/",
    Programa: "Full Stack Java",
    País: "Argentina",
    Estado: "",
    Costo: 955,
    Beca: 80,
    Modalidad: "Tiempo parcial",
    Duración: "36 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Generation",
    URL: "https://mexico.generation.org/cdmx-online/desarrolladora-java-full-stack/",
    Programa: "Full Stack Java",
    País: "México",
    Estado: "CDMX",
    Costo: 0,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "12 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Hack A Boss",
    URL: "https://www.hackaboss.com",
    Programa: "Full Stack JS",
    País: "España",
    Estado: "",
    Costo: 7310,
    Beca: 13,
    Modalidad: "Tiempo parcial",
    Duración: "20 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Hack Academy",
    URL: "https://ha.dev",
    Programa: "Full Stack JS",
    País: "Argentina",
    Estado: "",
    Costo: 3900,
    Beca: 15,
    Modalidad: "Tiempo completo",
    Duración: "12 semanas",
    "En línea": "Sí",
    Comentarios: "Módulos individuales a tiempo parcial",
  },
  {
    Bootcamp: "Ironhack",
    URL: "https://www.ironhack.com/en/web-development/remote",
    Programa: "Full Stack JS",
    País: "Internacional",
    Estado: "",
    Costo: 5259,
    Beca: "",
    Modalidad: "Tiempo completo o parcial",
    Duración: "9 - 24 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "ISDI Coders",
    URL: "https://isdicoders.com/es",
    Programa: "Full Stack JS",
    País: "España",
    Estado: "",
    Costo: 4830,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "27 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Jalasoft",
    URL: "https://jalasoft.site",
    Programa: "Full Stack JS",
    País: "Internacional",
    Estado: "",
    Costo: 0,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "Compromiso de servicio social por 16 meses",
  },
  {
    Bootcamp: "KeepCoding",
    URL: "https://keepcoding.io/nuestros-bootcamps/full-stack-web-bootcamp/",
    Programa: "Full Stack JS",
    País: "Internacional",
    Estado: "",
    Costo: 6000,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "32 semanas",
    "En línea": "Sí",
    Comentarios: "Descuento a residentes de LATAM.",
  },
  {
    Bootcamp: "Kodemia",
    URL: "https://kodemia.mx/javascript-live",
    Programa: "Full Stack JS",
    País: "México",
    Estado: "",
    Costo: 3700,
    Beca: 18,
    Modalidad: "Tiempo parcial",
    Duración: "22 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Laboratoria",
    URL: "https://www.laboratoria.la",
    Programa: "Full Stack JS",
    País: "Chile",
    Estado: "Santiago",
    Costo: 2111,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "24 semanas",
    "En línea": "Sí",
    Comentarios: "ISA (9%). Exclusivo mujeres.",
  },
  {
    Bootcamp: "Le Wagon",
    URL: "https://www.lewagon.com",
    Programa: "Full Stack Ruby",
    País: "Internacional",
    Estado: "",
    Costo: 5500,
    Beca: "",
    Modalidad: "Tiempo completo o parcial",
    Duración: "9 - 24 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "LoopGK",
    URL: "https://loopgk.com/bootcamp/",
    Programa: "Full Stack Python",
    País: "México",
    Estado: "Villahermosa",
    Costo: 120,
    Beca: 50,
    Modalidad: "Tiempo parcial",
    Duración: "11 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "MindHub",
    URL: "https://mindhubweb.com/bootcamps",
    Programa: "Full Stack JS | Java",
    País: "Internacional",
    Estado: "",
    Costo: 4400,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "ISA opcional.",
  },
  {
    Bootcamp: "MUKTEK",
    URL: "https://www.muktek.com/cursos/js",
    Programa: "Full Stack JS",
    País: "México",
    Estado: "",
    Costo: 3890,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "28 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "NUCBA",
    URL: "https://nucba.com.ar",
    Programa: "Full Stack JS",
    País: "Argentina",
    Estado: "",
    Costo: 530,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "48 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Rolling Code",
    URL: "https://rollingcodeschool.com/",
    Programa: "Full Stack JS",
    País: "Argentina",
    Estado: "",
    Costo: 660,
    Beca: 15,
    Modalidad: "Tiempo parcial",
    Duración: "24 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Skills For Industry",
    URL: "https://www.skillsforindustry.org",
    Programa: "Full Stack JS",
    País: "Internacional",
    Estado: "",
    Costo: 4000,
    Beca: "",
    Modalidad: "Tiempo completo o parcial",
    Duración: "16 - 32 semanas",
    "En línea": "Sí",
    Comentarios: "ISA (15%).",
  },
  {
    Bootcamp: "SocraTech",
    URL: "https://socratech.es",
    Programa: "Full Stack JS",
    País: "España",
    Estado: "",
    Costo: 5530,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Soy Henry",
    URL: "https://www.soyhenry.com/webfullstack",
    Programa: "Full Stack JS",
    País: "Internacional",
    Estado: "",
    Costo: 4000,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "16 semanas",
    "En línea": "Sí",
    Comentarios: "ISA (15%).",
  },
  {
    Bootcamp: "Start Coding",
    URL: "https://startcoding.ai",
    Programa: "Front End | Back End | Mobile",
    País: "Argentina",
    Estado: "",
    Costo: 0,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "24 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Tec de Monterrey",
    URL: "https://bootcamp.tec.mx/coding/es/",
    Programa: "Full Stack JS",
    País: "México",
    Estado: "",
    Costo: 5564,
    Beca: 8,
    Modalidad: "Tiempo parcial",
    Duración: "24 semanas",
    "En línea": "Sí",
    Comentarios: "Curso dictado en inglés.",
  },
  {
    Bootcamp: "The Bridge",
    URL: "https://www.thebridge.tech/bootcamps/bootcamp-fullstack-developer",
    Programa: "Full Stack JS",
    País: "España",
    Estado: "",
    Costo: 7870,
    Beca: "",
    Modalidad: "Tiempo completo",
    Duración: "15 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Tzuzul Code",
    URL: "https://www.tzuzulcode.com",
    Programa: "Full Stack JS",
    País: "México",
    Estado: "",
    Costo: 0,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "12 semanas",
    "En línea": "Sí",
    Comentarios: "Acceso a todos los bootcamps tras aceptación",
  },
  {
    Bootcamp: "U Camp",
    URL: "https://u-camp.utel.edu.mx/mexico",
    Programa: "Full Stack JS",
    País: "México",
    Estado: "",
    Costo: 1125,
    Beca: "",
    Modalidad: "Tiempo parcial",
    Duración: "28 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "UpgradeHub",
    URL: "https://www.upgrade-hub.com",
    Programa: "Full Stack Web",
    País: "España",
    Estado: "",
    Costo: 7250,
    Beca: "",
    Modalidad: "Tiempo completo o parcial",
    Duración: "10 - 24 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Tripleten",
    URL: "https://tripleten.com/es-col/",
    Programa: "Full Stack Web",
    País: "Internacional",
    Estado: "",
    Costo: 1000,
    Beca: "",
    Modalidad: "Tiempo completo o parcial",
    Duración: "40 semanas",
    "En línea": "Sí",
    Comentarios: "",
  },
  {
    Bootcamp: "Boolean",
    URL: "https://boolean.cl/bootcamps",
    Programa: "Full Stack JS | Python | Ruby",
    País: "Chile",
    Estado: "",
    Costo: 2500,
    Beca: "Crédito blando ",
    Modalidad: "Tiempo completo o parcial",
    Duración: "12|24|48 semanas",
    "En línea": "Sí",
    Comentarios: "Metodología extreme programming. Máximo 12 participantes por instructor",
  },
];
